import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import {
  TEventAnalyticsFilters,
  TEventStandingsFilters,
  TEventStandingsList,
  TEventStandingsState
} from '../libs/store';
import { TGetEventAnalyticsFiltersParams, TGetEventStandingsParams } from '../services/apiService';

const getInitialState = (): TEventStandingsState => ({
  eventStandingsFilters: {
    isLoading: false,
    isLoaded: false,
    collections: []
  },
  eventStandings: {
    isLoading: false,
    isLoaded: false,
    data: undefined,
    ui: {}
  },
  eventAnalyticsFilters: {
    isLoading: false,
    isLoaded: false,
    teams: [],
    zoneIds: [],
    affixes: [],
    ui: {},
    collections: [],
    brackets: []
  },

  requestPending: false
});

// Action Types
const LOAD_EVENT_STANDINGS_LIST = 'EVENT_STANDINGS/LOAD_EVENT_STANDINGS_LIST';
const GET_EVENT_STANDINGS_LIST = 'EVENT_STANDINGS/GET_EVENT_STANDINGS_LIST';

const LOAD_EVENT_ANALYTICS_FILTERS = 'EVENT_STANDINGS/LOAD_EVENT_ANALYTICS_FILTERS';
const GET_EVENT_ANALYTICS_FILTERS = 'EVENT_STANDINGS/GET_EVENT_ANALYTICS_FILTERS';

const LOAD_EVENT_STANDINGS_FILTERS = 'EVENT_STANDINGS/LOAD_EVENT_STANDINGS_FILTERS';
const GET_EVENT_STANDINGS_FILTERS = 'EVENT_STANDINGS/GET_EVENT_STANDINGS_FILTERS';

const SET_REQUEST_PENDING = 'EVENT_STANDINGS/SET_REQUEST_PENDING';

// Actions
const getEventStandingsFilters = () => {
  return {
    type: GET_EVENT_STANDINGS_FILTERS
  };
};

const loadEventStandingsList = (payload: TEventStandingsList) => {
  return {
    type: LOAD_EVENT_STANDINGS_LIST,
    payload: {
      eventStandings: payload
    }
  };
};

const loadEventStandingsFilters = (payload: TEventStandingsFilters) => {
  return {
    type: LOAD_EVENT_STANDINGS_FILTERS,
    payload: {
      eventStandingsFilters: payload
    }
  };
};

const getEventStandingsList = (params: TGetEventStandingsParams) => {
  return {
    type: GET_EVENT_STANDINGS_LIST,
    payload: params
  };
};

const getEventAnalyticsFilters = (params: TGetEventAnalyticsFiltersParams) => {
  return {
    type: GET_EVENT_ANALYTICS_FILTERS,
    payload: params
  };
};

const loadEventAnalyticsFilters = (payload: TEventAnalyticsFilters) => {
  return {
    type: LOAD_EVENT_ANALYTICS_FILTERS,
    payload: {
      eventAnalyticsFilters: payload
    }
  };
};

const setRequestPending = (payload: boolean) => {
  return {
    type: SET_REQUEST_PENDING,
    payload
  };
};

export function reducer(state = getInitialState(), action: TAction<any>) {
  switch (action.type) {
    case SET_REQUEST_PENDING:
    case LOAD_EVENT_STANDINGS_LIST:
    case LOAD_EVENT_ANALYTICS_FILTERS:
    case LOAD_EVENT_STANDINGS_FILTERS: {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
}

export const actions = {
  loadEventAnalyticsFilters,
  loadEventStandingsFilters,
  loadEventStandingsList,

  getEventStandingsFilters,
  getEventStandingsList,
  getEventAnalyticsFilters,

  setRequestPending
};

export const actionTypes = {
  SET_REQUEST_PENDING,
  LOAD_EVENT_STANDINGS_LIST,
  LOAD_EVENT_STANDINGS_FILTERS,
  LOAD_EVENT_ANALYTICS_FILTERS,

  GET_EVENT_STANDINGS_FILTERS,
  GET_EVENT_STANDINGS_LIST,
  GET_EVENT_ANALYTICS_FILTERS
};
